import { cn } from '@/lib/utils';
import {
  TONE_BG,
  TONE_PILL,
  type StatusTone,
} from '@/lib/widget-status';

interface StatusBadgeProps {
  tone: StatusTone;
  label: string;
  className?: string;
}

export function StatusBadge({ tone, label, className }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 text-[11.5px] font-semibold px-2.5 py-0.5 rounded-full whitespace-nowrap',
        TONE_PILL[tone],
        className,
      )}
    >
      <span className={cn('w-1.5 h-1.5 rounded-full shrink-0', TONE_BG[tone])} />
      {label}
    </span>
  );
}
